import { FileTransfer,FileTransferObject } from '@ionic-native/file-transfer';
import { File } from '@ionic-native/file';
import { BllResimler } from './../../../providers/bll/bll-resimler';
import { DalProvider } from './../../../providers/dal/dal';
import { SyncProvider } from './../../../providers/syncProvider';
import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';



@Component({
  selector: 'page-data-sync',
  templateUrl: 'data-sync.html',
})
export class DataSyncPage {

  constructor(public navCtrl: NavController,
    public loadingCtrl: LoadingController,
    public ortak: Ortak,
    public dalProvider: DalProvider,
    public syncProvider: SyncProvider,
    public bllresim:BllResimler,
    public file:File,
    public transfer:FileTransfer,
    public navParams: NavParams) {
  }


  stoklar() {
    let loading = this.loadingCtrl.create({
      content: "Stoklar Getiriliyor"
    });
    loading.present();
    this.syncProvider.stokKartiSunucudanGetir().then(a => {
      loading.dismiss();
    }).catch(x => {
      loading.dismiss();
      this.ortak.showBasicAlert("Başarılı", "Stoklar Getirildi");
    });
  }
  stokbilgisiniGetir() {
    let loading = this.loadingCtrl.create({
      content: "Stok Bilgileri  Getiriliyor"
    });
    loading.present();
    this.syncProvider.stokBilgisiSunucudanGetir().then(a => {
      loading.dismiss();
    }).catch(x => {
      loading.dismiss();
      this.ortak.showBasicAlert("Başarılı", "Stok Bilgileri Getirildi");
    });
  }
  cariKartlariGetir() {
    let loading = this.loadingCtrl.create({
      content: "Cari Kartlar Getiriliyor"
    });
    loading.present();
    this.syncProvider.cariKartiSunucudanGetir().then(a => {
      loading.dismiss();
    }).catch(x => {
      loading.dismiss();
      this.ortak.showBasicAlert("Başarılı", "Cari Kartlar Getirildi");
    });
  }
  cariKartBilgileriniGetir() {
    let loading = this.loadingCtrl.create({
      content: "Cari Kart Bilgileri Getiriliyor"
    });
    loading.present();
    this.syncProvider.cariKartViewSunucudanGetir().then(a => {
      loading.dismiss();
    }).catch(x => {
      loading.dismiss();
      this.ortak.showBasicAlert("Başarılı", "Cari Kart Bilgileri Getirildi");
    });
  }
  birimler() {
    let loading = this.loadingCtrl.create({
      content: Ortak.dilKaynaklari["islem_yapiliyor_text"]
    });
    loading.present();
    this.syncProvider.BirimleriSunucudanGetir().then(a => {
      loading.dismiss();
    }).catch(x => {
      loading.dismiss();
      this.ortak.presentToast(Ortak.dilKaynaklari["internet_baglanti_kontrol"], 3000)
    });
  }
  markalar() {
    let loading = this.loadingCtrl.create({
      content: Ortak.dilKaynaklari["islem_yapiliyor_text"]
    });
    loading.present();
    this.syncProvider.MarkalariSunucudanGetir().then(a => {
      loading.dismiss();
    }).catch(x => {
      loading.dismiss();
      this.ortak.presentToast(Ortak.dilKaynaklari["internet_baglanti_kontrol"], 3000)
    });
  }
  kategoriler() {
    let loading = this.loadingCtrl.create({
      content: "Kategoriler Getiriliyor"
    });
    loading.present();
    this.syncProvider.KategorileriSunucudanGetir().then(a => {
      loading.dismiss();
    }).catch(x => {
      loading.dismiss();
      this.ortak.showBasicAlert("Başarılı", "Kategoriler Getirildi");
    });
  }
  ResimleriGetir()
  {
    let loading = this.loadingCtrl.create({
      content: "Resimler Getiriliyor"
    });
    loading.present();
    this.bllresim.syncResimler().then(a => {
      loading.dismiss();
    }).catch(x => {
      loading.dismiss();
      this.ortak.showBasicAlert("Başarılı", "Resimler Getirildi");
    });
  }
  kdvler() {
    let loading = this.loadingCtrl.create({
      content: "Kdv Grupları Getiriliyor..."
    });
    loading.present();
    this.syncProvider.KdvleriSunucudanGetir().then(a => {
      loading.dismiss();
    }).catch(x => {
      loading.dismiss();
      this.ortak.showBasicAlert("Başarılı", "Kdv Gruplari Getirildi");
    });
  }
  sifirla() {
    this.ortak.showConfirmAlert("Uyarı", "Program üzerinde kaydedilmiş veriler silinecek onaylıyormusunuz?  Not:Sunucu Üzerindeki Veriler Silinmez").then(a => {
      Ortak.sqlType = "web";
      var sqlDriver;
      if (Ortak.sqlType == "web") {
        sqlDriver = {
          database: "VT.db",
          type: "websql",
          storage: "web",
        };
      }
      else {
        sqlDriver = {
          database: "MRC_5.db",
          type: "websql",
          storage: "sqlite",
        };
      }
      return new Promise((res, err) => {
        this.dalProvider.SifirlanacakTablolariSil().then(a => {
          this.dalProvider.createAndGetConnection(sqlDriver).then(k => {
            res();
            this.ortak.showBasicAlert("", "Tüm veriler Sıfırlandı");
          });
        }).catch(z => {
          err();
          console.log(z);
        })
      })
    });
  }
  download() {
  
    var file = new File();
    const fileTransfer: FileTransferObject = this.transfer.create();
    const url = 'http://localhost:1010/assets/images/stok/1/bc0b3718-a17c-f87c-f6e5-635458baf983.jpg';

    var filename="asd.jpd";
    var localpath=file.dataDirectory+filename;

    fileTransfer.download(url, localpath).then((entry) => {
  
    
    }, (error) => {
   
    });

  }

}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/data-sync/data-sync.ts